export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/angelo-pantazis-d184f36242ad7d39070b765346fee30b.jpg";